import {
  createMuiTheme
} from '@material-ui/core/styles';

const customTheme = () =>
  createMuiTheme({
    palette: {
      type:  'light',
      primary: {
        main: '#3e3799',
        contrastText:'#fff'
      },
      secondary: {
        main:  '#7972db',
      },
      white:{
        color:'#fff'
      }
    },
    overrides: {
      MuiPopover: {
        paper: {
          borderRadius: 2,
        },
      },
      MuiButton: {
        root: {
          borderRadius: 4,
          textTransform: 'none',
          fontSize: '0.95em',
          
        },
      },
      MuiTypography: {
        root: {
          wordWrap: 'anywhere',
        },
      },
      MuiListItem: {
        root: {
          '&$selected': {
            borderRight: '5px solid #3e3799',
          },
        },
      },
      MuiAvatar: {
        colorDefault: {
          backgroundColor: '#7691b5',
          color: '#fff',
        },
      },
      MuiSelect: {
        select: {
          '&:focus': {
            display: 'flex',
            alignItems: 'center',
          },
        },
        selectMenu: {
          display: 'flex',
          alignItems: 'center',
        },
      },
      MuiBottomNavigationAction:{
        root: {
          color: '#fff',
          backgroundColor:'#546fb8',
          '&$selected': {
            color: '#fcd116',
          },
        },
        
      },
    },
    props: {
      MuiButton: {
        disableElevation: true,
      },
    },
    
  });

export default customTheme;
